<template>
  <b-row>
    <b-col
      :lg="6" :offset-lg="3"
      :md="8" :offset-md="2"
    >
     <vue-form-generator
        :schema="schema"
        :model="form"
        :options="formOptions"
        ref="purchaseForm"
      ></vue-form-generator>
    </b-col>
  </b-row>
</template>
<script>
import VueFormGenerator from 'vue-form-generator';
import schemaDefinition from './schema';

export default {
  components: {
    'vue-form-generator': VueFormGenerator.component,
  },
  props: {
    form: Object,
  },
  data() {
    return {
      schema: schemaDefinition.schema,
      formOptions: schemaDefinition.formOptions,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/new_deal/components/purchase/PurchaseSection.vue